<template>
    <div>
        <div class="card dashcard mb-3">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa-regular fa-calendar fa-fw"
                            type="select"
                            placeholder="Orçamento"
                            :optionsList="[
                                { id: 'M', search: 'Agendamento' },
                                { id: 'A', search: 'Atendimento' },
                                { id: 'P', search: 'Adiantamento' },
                            ]"
                            optionsData="id"
                            v-model="filtro.tipo_data" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            type="select"
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            icon="fa fa-building fa-fw"
                            placeholder="Todas as Unidades..."
                            v-model="filtro.id_unidade_operacao" />
                    </div>
                    
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-6">
                        <az-input 
                            icon="fa-solid fa-user-injured"
                            placeholder="Selecionar paciente..."
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="filtro.paciente" 
                            :optimized_ac="true" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa-solid fa-user-doctor"
                            placeholder="Profissional Solicitante..."
                            type="autocomplete"
                            optionsMode="aql"
                            service="medico_solicitantes.index"
                            optionsDisplay="search"
                            optionsData="id_medico_solicitante"
                            :optionsSync="true"
                            v-model="filtro.id_medico_solicitante" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa-solid fa-cart-shopping fa-fw"
                            type="select"
                            placeholder="Todos..."
                            :optionsList="[
                                { id: 'S', search: 'Convertidos' },
                                { id: 'N', search: 'Não Convertidos' },
                            ]"
                            optionsData="id"
                            v-model="filtro.convertido" />
                    </div>
                    <div class="col col-12 col-md-3" v-if="false">
                        <az-input
                            icon="far fa-credit-card fa-fw"
                            type="select" 
                            optionsMode="aql"
                            optionsData="id_operadora"
                            optionsDisplay="st_operadora"
                            service="operadoras.index"
                            :optionsParm="{ 
                                fatura: true,
                                classes: true,
                                lista: true
                            }"
                            optionsName="operadoras-para-fatura-2"
                            placeholder="Operadora..."
                            v-model="filtro.id_operadora">
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12" :class="filtro.tipo == 'A' ? 'col-md-4' : 'col-md-9'">
                        <az-input
                            icon="fa fa-search fa-fw"
                            placeholder="Pesquisar..."
                            v-model="filtro.pesquisa">
                            <template v-slot:buttonposb>
                                <print-export printid="orcamentos" :dados="dados_exportacao" pagina="crm-orcamentos" :parms="parms_relatorios"/>
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-2" v-if="filtro.tipo == 'A'">
                        <az-input
                            icon="fa-solid fa-filter fa-fw"
                            type="select"
                            placeholder="Todos os Status..."
                            optionsMode="aql"
                            service="contato_status.index"
                            :optionsParm="{ model: 'retornoAtendimento', ativos: true }"
                            :optionsName="'cont_status_orcamento'"
                            optionsData="id_contato_status"
                            v-model="filtro.id_contato_status" />
                    </div>

                    <div class="col col-12 col-md-3" v-if="filtro.tipo == 'A'">
                        <az-input
                            icon="fa-solid fa-object-group fa-fw"
                            type="select"
                            placeholder="Não Agrupar"
                            :optionsList="[
                                // { id: 'C', search: 'Agrupar por Status' },
                                { id: 'O', search: 'Agrupar por Operadora/Plano' },
                                { id: 'U', search: 'Agrupar por Responsável' },
                                { id: 'S', search: 'Agrupar por Solicitante' },
                            ]"
                            optionsData="id"
                            v-model="filtro.agrupa" />
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input   
                            type="button-group"
                            :optionsList="[{ id: 'S', search: 'Sintético' }, { id: 'A', search: 'Analítico' }]"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtro.tipo"
                            @input="load()" />
                    </div>
                </div>
            </div>
        </div>

        <az-empty-state v-if="!lista.length" msg="Nenhum orçamento identificado." icon="fa-solid fa-dollar-sign"  />

        <div v-else-if="dados.tipo == 'S'">

            <div v-if="dados && dados.tags && dados.tags.length">
                <table class="table table-sm border-0 mb-1 table-responsive">
                    <tr>
                        <td class="text-nowrap">
                            <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in dados.tags" :key="icx">
                                <span class="badge badge-success mr-1" >
                                    {{ classe }}
                                </span>
                            </a>
                        </td>
                    </tr>
                </table>
            </div>

            <div  id="orcamentos">

                <cabecalho-generico titulo="Orçamentos (Sintético)">
                    <div>
                        <div v-if="dados.inicio">
                            Período: {{ $util.getFormatDate(dados.inicio) }} a {{ $util.getFormatDate(dados.fim) }}
                        </div>
                        <div v-if="filtro.pesquisa">
                            Pesquisa: {{ filtro.pesquisa }}
                        </div>
                    </div>
                </cabecalho-generico>

                <table class="table table-hover bg-white cabecalho-fixo">
                    <thead>
                        <tr>
                            <th width="8%">Status</th>
                            <th width="6%" class="text-right">Ticket Médio</th>
                            <th width="8%" class="text-right">Qtde</th>
                            <th width="13%" class="text-right">Orçado</th>
                            <th width="13%" class="text-right">Descontos</th>
                            <th width="13%" class="text-right">Adiantado (A)</th>
                            <th width="13%" class="text-right">Atendido</th>
                            <th width="13%" class="text-right">Pago (B)</th>
                            <th width="13%" class="text-right">Pago Total (A+B)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, iix) in lista" :key="iix">
                            <td class="text-nowrap">{{ item.convertido }}</td>
                            <td class="text-right">{{ $util.formatMoeda(item.vlr_total / item.qtde) }}</td>
                            <td class="text-right">{{ item.qtde }}</td>
                            <td class="text-right">{{ $util.formatMoeda(item.vlr_total) }}</td>
                            <td class="text-right">{{ $util.formatMoeda(( item.vlr_descontos ? item.vlr_descontos : 0 ) + ( item.vlr_atend_descontos ? item.vlr_atend_descontos : 0 )) }}</td>
                            <td class="text-right">{{ $util.formatMoeda(( item.vlr_adiantado ? item.vlr_adiantado : 0 ) + ( item.vlr_atend_adiantado ? item.vlr_atend_adiantado : 0 )) }}
                                <div v-if="$util.formatMoeda(item.vlr_adiantado_pendente) > 0" class="small text-muted">
                                    Pend: {{ $util.formatMoeda(item.vlr_adiantado_pendente) }}
                                </div>
                            </td>
                            <td class="text-right">{{ $util.formatMoeda(item.vlr_atendido) }}</td>
                            <td class="text-right">{{ $util.formatMoeda(item.vlr_atendido_pago) }}</td>
                            <td class="text-right">{{ $util.formatMoeda(parseFloat(item.vlr_atendido_pago ? item.vlr_atendido_pago : 0) 
                                                + parseFloat(item.vlr_adiantado ? item.vlr_adiantado : 0)
                                                ) }}</td>
                        </tr>
                    </tbody>
                    <tfoot v-if="lista && lista.length">
                        <tr>
                            <th>Total</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, 'vlr_total') / totalizar(lista, 'qtde')) }}</th>
                            <th class="text-right">{{ totalizar(lista, 'qtde') }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, 'vlr_total')) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, 'vlr_descontos') + totalizar(lista, 'vlr_atend_descontos')) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, 'vlr_adiantado') + totalizar(lista, 'vlr_atend_adiantado')) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, 'vlr_atendido')) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, 'vlr_atendido_pago')) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, 'vlr_atendido_pago') + totalizar(lista, 'vlr_adiantado')) }}</th>
                        </tr>
                    </tfoot>
                </table>

                <div class="alert alert-secondary small">
                    <div>
                        <strong>Adiantado</strong> = Valores recebidos dos orçamentos listados, provenientes de adiantamentos.
                    </div>
                    <div>
                        <strong>Atendimento</strong> = Valores já atendidos dos orçamentos listados, independente se o pagamento foi realizado ou não.
                    </div>
                    <div>
                        <strong>Pago</strong> = Valores recebidos dos orçamentos listados, provenientes de pagamentos realizados no ato do atendimento.
                    </div>

                    <div class="mt-2">A soma dos dois valores de A + B, representa o total recebido em caixa dos orçamentos listados. </div>

                    <hr>

                    <div>
                        <strong>Convertido</strong> = Representa o conjunto de orçamentos, para os quais já houve um agendamento e/ou atendimento.
                    </div>
                </div>
            </div>
            
        </div>

        <div v-else-if="dados.tipo == 'A'">

            <div class="d-flex justify-content-between">
                <div>
                    <table class="table table-sm border-0 mb-1 table-responsive">
                        <tr>
                            <td class="text-nowrap">
                                <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in lista_classes" :key="icx">
                                    <span class="badge badge-success mr-1" >
                                        {{ classe }}
                                    </span>
                                </a>
                            </td>
                        </tr>
                    </table>
                </div>
                <div>
                    <a href="#" @click.prevent="toggle_expandido()">
                        <i class="fa-solid fa-minimize" v-if="expandido"></i>
                        <i class="fa-solid fa-maximize" v-else></i>
                    </a>
                </div>
            </div>

            <div id="orcamentos">

                <cabecalho-generico titulo="Orçamentos (Analítico)">
                    <div>
                        <div v-if="dados.inicio">
                            Período: {{ $util.getFormatDate(dados.inicio) }} a {{ $util.getFormatDate(dados.fim) }}
                        </div>
                        <div v-if="filtro.pesquisa">
                            Pesquisa: {{ filtro.pesquisa }}
                        </div>
                    </div>
                </cabecalho-generico>

                <pre v-if="1==0">{{ lista_agrupada }}</pre>

                <table class="table table-sm table-hover bg-white small cabecalho-fixo">
                    <thead>
                        <table-th title="Id" v-model="ordem_orc" sortby="id_orcamento"></table-th>
                        <table-th title="Paciente" v-model="ordem_orc" sortby="st_titulo"></table-th>
                        <th>Solicitante</th>
                        <th>Atendimento</th>
                        <table-th align="text-right" title="Orçado" v-model="ordem_orc" sortby="valor_total"></table-th>
                        <th class="text-right">Desconto</th>
                        <th class="text-right">Final</th>
                        <th class="text-right">Adiantado (A)</th>
                        <th class="text-right">Atendido</th>
                        <th class="text-right">Pago (B)</th>
                        <th class="text-right">Pago Total (A+B)</th>
                    </thead>
                    <tbody>
                        <template v-for="(itens, grupo, igx) in lista_agrupada">
                            <tr :key="igx" class="table-secondary" v-if="true">
                                <th colspan="4">
                                    <a href="#" @click.prevent="toggle(grupo)" class="card-link mr-2">
                                        <i class="fa-regular fa-square-plus" v-if="grupos[grupo]"></i>
                                        <i class="fa-regular fa-square-minus" v-else></i>
                                    </a>
                                    {{ grupo == 'undefined' ? 'Não Definido' : grupo }}
                                    <span class="badge badge-secondary ml-1">{{ itens.length }}</span>
                                </th>
                                <th class="text-right">{{ $util.formatMoeda(totalizar(itens, 'valor_total')) }}</th>
                                <th class="text-right">{{ $util.formatMoeda(totalizar(itens, 'valor_desconto')) }}</th>
                                <th class="text-right">{{ $util.formatMoeda(totalizar(itens, 'valor_final')) }}</th>
                                <th class="text-right">{{ $util.formatMoeda(totalizar(itens, '', valor_pago_adiantado)) }}</th>
                                <th class="text-right">{{ $util.formatMoeda(totalizar(itens, '', valor_atendido)) }}</th>
                                <th class="text-right">{{ $util.formatMoeda(totalizar(itens, '', valor_atendido_pago)) }}</th>
                                <th class="text-right">{{ $util.formatMoeda(totalizar(itens, '', valor_atendido_pago) + totalizar(itens, '', valor_pago_adiantado)) }}</th>
                            </tr>
                            <template v-if="!grupos[grupo]">
                                <tr v-for="(item, iix) in itens" :key="igx + '.' + iix" :class="( item.contato && item.contato.contato_status && item.contato.contato_status.st_color ) ? 'table-' + item.contato.contato_status.st_color : ''">
                                    <td>
                                        <a href="#" @click.prevent="abrir_orcamento(item)" class="card-link">
                                            #{{ item.id_orcamento }}
                                        </a>
                                        <div class="text-muted">
                                            {{ $util.getFormatDate(item.created_at) }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="d-flex justify-content-between">
                                            <div>
                                                <div>
                                                    {{ item.st_titulo ? item.st_titulo : item.st_nome }}
                                                </div>
                                                <div>
                                                    <span class="small text-muted">{{ item.plano.search }}</span>

                                                    <a href="#" @click.prevent="editar_contatos(item)" class="ml-1">
                                                        <i class="fa-solid fa-comments"></i>
                                                    </a>

                                                    <a href="#" @click.prevent="filtrar(item.contato.contato_status.search)" v-if="item.contato && item.contato.contato_status" class="ml-1">
                                                        <span :class="'badge badge-' + item.contato.contato_status.st_color">
                                                            {{ item.contato.contato_status.search }}
                                                        </span>
                                                    </a>

                                                    <span v-if="item.js_classes && item.js_classes.length" class="ml-3">
                                                        <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in item.js_classes" :key="icx">
                                                            <span class="badge badge-success mr-1" >
                                                                {{ classe }}
                                                            </span>
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="d-print-none mr-2" id="acesso-perfil-paciente">
                                                <paciente-float-panel :paciente="item.paciente" v-if="item.paciente"></paciente-float-panel>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <span v-if="item.solicitante">
                                            {{ item.solicitante.st_nome }}
                                        </span>
                                    </td>
                                    <td>
                                        <div class="text-muted" v-if="item.paciente && item.paciente.ultimo_atendimento && !item.marcacoes.length">
                                            Último: #{{ item.paciente.ultimo_atendimento.id_atendimento }} / {{ $util.getFormatDate(item.paciente.ultimo_atendimento.dt_inicio) }}
                                        </div>
                                        <div v-for="(marcacao, iax) in item.marcacoes" :key="iax">
                                            <span v-if="marcacao.id_atendimento">
                                                <a href="#" @click.prevent="abrir_atendimento(marcacao.id_atendimento)" class="card-link">
                                                    #{{ marcacao.id_atendimento }}
                                                    <i class="fa fa-caret-right mx-1" aria-hidden="true"></i> 
                                                    {{ $util.getFormatDate(marcacao.atendimento.dt_inicio, 'DD/MM') }}
                                                    <template v-if="marcacao.usuario">
                                                        <i class="fa fa-caret-right mx-1" aria-hidden="true"></i> 
                                                        {{ marcacao.usuario.st_login }}
                                                    </template>
                                                </a>
                                            </span>
                                            <span v-else>
                                                Marcado
                                                <i class="fa fa-caret-right mx-1" aria-hidden="true"></i> 
                                                {{ $util.getFormatDate(marcacao.dt_inicio) }}
                                            </span>
                                        </div>
                                    </td>
                                    <td class="text-right">{{ $util.formatMoeda(item.valor_total) }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(item.valor_desconto) }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(item.valor_final) }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(valor_pago_adiantado(item)) }}
                                        <div v-if="$util.formatMoeda(valor_pago_adiantado_pendente(item)) > 0" class="small text-muted">
                                            Pend: {{ $util.formatMoeda(valor_pago_adiantado_pendente(item)) }}
                                        </div>
                                    </td>
                                    <td class="text-right">{{ $util.formatMoeda(valor_atendido(item)) }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(valor_atendido_pago(item)) }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(valor_atendido_pago(item) + valor_pago_adiantado(item)) }}</td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="4">Total
                                <span class="badge badge-secondary ml-1">{{ lista.length }}</span>
                            </th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, 'valor_total')) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, 'valor_desconto')) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, 'valor_final')) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, '', valor_pago_adiantado)) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, '', valor_atendido)) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, '', valor_atendido_pago)) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(lista, '', valor_atendido_pago) + totalizar(lista, '', valor_pago_adiantado)) }}</th>
                        </tr>
                    </tfoot>
                </table>

            </div>

            <pre v-if="false">{{ dados }}</pre>
        </div>

        <br><br><br><br><br>

        <registrar-contatos 
            :lista_status="lista_status.filter(item => item.id_contato_status != 'R')" 
            ref="regcontatos" 
            @refresh="load()">
            <template v-slot:info>
                <div v-if="edicao_contato.js_procedimentos && edicao_contato.js_procedimentos.length">
                    <table class="table table-sm small">
                        <tr>
                            <td>Valor</td>
                            <td class="text-right">{{ $util.formatMoeda(edicao_contato.valor_total) }}</td>
                        </tr>
                        <template v-if="edicao_contato.valor_desconto > 0">
                            <tr>
                                <td>
                                    Desconto
                                    <template v-if="edicao_contato.id_desconto_tipo">
                                        <span class="ml-2" v-if="edicao_contato && edicao_contato.id_usuario_desconto">
                                            <i class="fa fa-check-circle text-success" aria-hidden="true" title="Desconto validado."></i>
                                        </span>
                                        <span class="ml-2" v-else-if="edicao_contato && edicao_contato.id_usuario_desconto === null">
                                            <i class="fa-solid fa-circle-question" title="Desconto aguardando aprovação."></i>
                                        </span>
                                    </template>
                                </td>
                                <td class="text-right">{{ $util.formatMoeda(edicao_contato.valor_desconto) }}</td>
                            </tr>

                            <tr>
                                <td><strong>Final</strong></td>
                                <td class="text-right"><strong>{{ $util.formatMoeda(edicao_contato.valor_final) }}</strong></td>
                            </tr>
                        </template>
                    </table>

                    <ul class="list-group">
                        <li class="list-group-item small" v-for="(orc_proc, iox) in edicao_contato.js_procedimentos" :key="iox">
                            {{ orc_proc.procedimento ? orc_proc.procedimento.search : '???' }}
                        </li>
                    </ul>
                </div>
            </template>
        </registrar-contatos>

        <detalhe-orcamento ref="detalhe_orcamento" />

    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import PacienteFloatPanel from '../../shared/PacienteFloatPanel.vue';
import TableTh from '../../shared/table/TableTh.vue';
import DetalheOrcamento from './DetalheOrcamento.vue';

export default {
    data() {
        return { 
            filtro: { 
                periodo: 'h', 
                id_unidade_operacao: "", 
                id_medico_solicitante: "", 
                id_operadora: "", 
                id_contato_status: "", 
                tipo: "S", 
                tipo_data: "", 
                convertido: "", 
                pesquisa: "", 
                paciente: "", 
                agrupa: "", 
                lista_status: [], 
            },
            dados: null, 
            grupos: [], 
            expandido: true, 
            lista_status: [], 
            edicao_contato: null, 
            ordem_orc: "", 
        };
    },

    components: { 
        AzPeriodo,
        AzInput, 
        AzEmptyState, 
        PrintExport, 
        CabecalhoGenerico, 
        RegistrarContatos, 
        PacienteFloatPanel,
        TableTh,  
        DetalheOrcamento, 
    },

    computed: { 
        parms_relatorios: function () { 
            if ( !this.lista ) { 
                return {};
            }

            return { 
                orcamento_id: this.lista.map(item => item.id_orcamento),
            };
        },

        dados_exportacao: function () { 
            if ( this.dados && this.dados.tipo == 'A' ) { 
                return this.lista.map(item => {
                    return {
                        id: item.id_orcamento,
                        data: this.$util.getFormatDate(item.created_at),
                        responsavel: item.usuario ? item.usuario.st_login : '',
                        paciente: item.st_titulo ? item.st_titulo : item.st_nome,
                        plano: item.plano ? item.plano.search : '',
                        solicitante: item.solicitante ? item.solicitante.st_nome : '',
                        atendimento: item.marcacoes.filter(marcacao => marcacao.id_atendimento).map(marcacao => '#' + marcacao.id_atendimento).join(', '),
                        orcado: this.$util.formatMoeda(item.valor_total),
                        desconto: this.$util.formatMoeda(item.valor_desconto),
                        final: this.$util.formatMoeda(item.valor_final),
                        adiantado: this.$util.formatMoeda(this.valor_pago_adiantado(item)),
                        atendido: this.$util.formatMoeda(this.valor_atendido(item)),
                        pago: this.$util.formatMoeda(this.valor_atendido_pago(item)),
                        pagototal: this.$util.formatMoeda(this.valor_atendido_pago(item) + this.valor_pago_adiantado(item)),
                        ultimo_atend: ( item.paciente && item.paciente.ultimo_atendimento ) ? '#' + item.paciente.ultimo_atendimento.id_atendimento : '',
                        ultimo_data: ( item.paciente && item.paciente.ultimo_atendimento ) ? this.$util.getFormatDate(item.paciente.ultimo_atendimento.dt_inicio) : '',
                        telefone: item.paciente 
                            ? item.paciente.cadastro.telefones.telefone
                            : item.st_telefone, 
                        celular: item.paciente 
                            ? item.paciente.cadastro.telefones.celular
                            : item.st_celular, 
                        email: item.paciente 
                            ? item.paciente.cadastro.st_email
                            : item.st_email, 
                        
                    };
                });
            }

            return null;
        },

        lista_agrupada: function () { 

            if ( this.dados.tipo == 'A' && this.filtro.agrupa ) { 
                
                let campo_agrupa;

                switch (this.filtro.agrupa) {
                    case 'S':
                        campo_agrupa = 'solicitante.st_nome';
                        break;

                    case 'U':
                        campo_agrupa = 'usuario.st_login';
                        break;

                    case 'O':
                        campo_agrupa = 'plano.search';
                        break;
                }

                return _.groupBy(_.orderBy(this.lista, campo_agrupa), campo_agrupa);

            }

            return _.groupBy(this.lista, () => 'Geral');

        },

        lista: function () { 
            if ( !this.dados || !this.dados.lista )
                return [];

            let reg = this.$util.getregex(this.filtro.pesquisa);

            let lista = this.dados.lista.filter(item => ( !this.filtro.pesquisa || this.dados.tipo == 'S' || reg.test(JSON.stringify(item)) ));

            if ( this.ordem_orc ) { 
                return _.orderBy(lista, this.ordem_orc.name, this.ordem_orc.direction);
            } else { 
                return lista;
            }

        },

        lista_classes() { 
            if ( !this.dados || !this.dados.lista )
                return [];

            return _.orderBy(
                    _.uniq(
                        this.dados.lista.flatMap(item => item.js_classes ? item.js_classes : [])
                    ),
                    item => item.toUpperCase()
                );
        },

    },

    methods: { 
        editar_contatos (item) { 
            this.$util.load(this, { 
                service: 'orcamentos',
                func: 'show',
                parms: { 
                    id: item.id_orcamento, 
                    contatos: true, 
                },
                loadTo: res => { 
                    this.edicao_contato = res;
                    this.lista_status = res.lista_status ? res.lista_status : []; 

                    this.edicao_contato.model = { 
                        type: 'orcamento',
                        id: item.id_orcamento,
                    };

                    this.$refs.regcontatos.editar(this.edicao_contato);
                }
            });
        },

        filtrar (texto) { 
            if ( this.filtro.pesquisa == '"' + texto + '"' ) { 
                this.filtro.pesquisa = "";
            } else { 
                this.filtro.pesquisa = '"' + texto + '"';
            }

            if ( this.filtro.tipo == 'S' ) { 
                this.$nextTick(() => { 
                    this.load();
                });
            }
        },

        toggle_expandido () { 
            let grupos = Object.keys(this.lista_agrupada);

            console.log('grupos', grupos);

            this.expandido = !this.expandido;

            if ( grupos.length ) { 
                grupos.forEach(grupo => { 
                    this.grupos[grupo] = !this.expandido;
                });
            }

            this.$forceUpdate();
        },

        toggle (grupo) { 
            this.grupos[grupo] = !_.get(this.grupos, grupo);
            this.$forceUpdate();
        },

        abrir_atendimento (id_atendimento) { 
            this.$util.abrir_atendimento(this, id_atendimento);
        },

        abrir_orcamento(orcamento) { 
            this.$refs.detalhe_orcamento.abrir(orcamento.id_orcamento);
            //this.$router.push({ name: 'rorcamento', params: { id_orcamento: orcamento.id_orcamento }});
        },

        totalizar (lista, campo, func = null) { 
            if ( func ) { 
                return lista.reduce((acc, item) => { 
                        return acc + func(item);
                    }, 0);
            }

            return lista.reduce((acc, item) => { 
                    return acc + parseFloat(item[campo] ? item[campo] : 0);
                }, 0);
        },

        valor_pago_adiantado_pendente (orcamento) { 
            if ( !orcamento.pagamento )
                return 0;

            return orcamento.pagamento.item_pagamento_atendimento_ativos.reduce((acc, itp) => { 
                return acc + parseFloat( itp.id_forma_pagamento == 98 ? itp.dc_valor : 0 )
            }, 0);
        },

        valor_pago_adiantado (orcamento) { 
            if ( !orcamento.pagamento )
                return this.valor_atendido_adiantado(orcamento);

            return orcamento.pagamento.item_pagamento_atendimento_ativos.reduce((acc, itp) => { 
                return acc + parseFloat( itp.id_forma_pagamento == 98 ? 0 : itp.dc_valor )
            }, 0) + this.valor_atendido_adiantado(orcamento);
        },

        valor_atendido (orcamento) { 
            if ( !orcamento.marcacoes )
                return 0;

            return orcamento.marcacoes.reduce((acc, marcacao) => { 
                return acc + ( ( marcacao.atendimento && marcacao.atendimento.total_items ) ? parseFloat(marcacao.atendimento.total_items.valor_total) : 0 );
            }, 0);
        },

        valor_atendido_pago (orcamento) { 
            if ( !orcamento.marcacoes )
                return 0;

            let itens = orcamento.marcacoes.flatMap(marcacao => { 
                if ( marcacao.atendimento && marcacao.atendimento.pagamento && marcacao.atendimento.pagamento.item_pagamento_atendimento_ativos ) { 
                    return marcacao.atendimento.pagamento.item_pagamento_atendimento_ativos.filter(itp => itp.id_forma_pagamento != 98 && itp.id_forma_pagamento != 99);
                }

                return []; 
            });

            itens = _.uniqBy(itens, 'id_item_pagamento_atendimento');

            let valor = itens.reduce((acc, item) => { 
                return acc + parseFloat(item.dc_valor); parseFloat(_.sumBy(item, 'dc_valor'));
            }, 0);

            return valor;
        },

        valor_atendido_adiantado (orcamento) { 
            if ( !orcamento.marcacoes )
                return 0;

            return orcamento.marcacoes.reduce((acc, marcacao) => { 
                return acc + ( ( marcacao.atendimento && marcacao.atendimento.pagamento && marcacao.atendimento.pagamento.item_pagamento_atendimento_ativos ) 
                    ? _.sumBy(
                        marcacao.atendimento.pagamento.item_pagamento_atendimento_ativos.filter(itp => itp.id_forma_pagamento == 99 && itp.id_pagamento_atendimento != _.get(orcamento, 'pagamento.id_pagamento_atendimento')), 
                        'dc_valor'
                    ) 
                    : 0 
                );
            }, 0);
        },

        load() { 
            this.$util.load(this, { 
                service: 'crm', 
                func: 'orcamentos', 
                parms: { 
                    ...this.filtro, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    },
    
    mounted() { 

        this.$store.commit("setBreadcrumb", [
            { name: "CRM", path: "/crm" },
            { name: "Orçamentos", path: "/crm/orcs" }
        ]);

    }


}
</script>
